import Reveal from "@/components/Reveal";
import Tilt3D from "@/components/Tilt3D";
import { TID } from "@/lib/testIds";
import { useSiteContent, resolveImg } from "@/admin/SiteContent";

const ASSET = "https://customer-assets.emergentagent.com/job_pure-rp-gaming/artifacts";

const DEFAULT_IMAGES = [
  { key: "lspd-alley", src: `${ASSET}/ic0bz4yf_Gemini_Generated_Image_vvk5iavvk5iavvk5.png`, caption: "Vicolo LSPD — Notte di servizio", tag: "Law" },
  { key: "garage", src: `${ASSET}/366fe2f0_Gemini_Generated_Image_rowin5rowin5rowi%20%281%29.png`, caption: "Officina privata — Carbon body", tag: "Garage" },
  { key: "vinewood-drive", src: `${ASSET}/fge5k7t7_Gemini_Generated_Image_rab8mvrab8mvrab8.png`, caption: "Vinewood Drive — Neon underglow", tag: "Veicoli" },
  { key: "penthouse", src: `${ASSET}/b4f5dpsr_Gemini_Generated_Image_8vcqty8vcqty8vcq.png`, caption: "Penthouse Vinewood — Skyline", tag: "Lifestyle" },
];

export const Gallery = () => {
  const { content } = useSiteContent();
  const IMAGES = (content?.gallery && content.gallery.length > 0
    ? content.gallery
    : DEFAULT_IMAGES
  ).map((g, i) => ({ ...g, key: g.key || `gallery-${i}`, src: resolveImg(g.src) }));

  return (
    <section
      id="gallery"
      data-testid={TID.gallery.root}
      className="relative py-24 sm:py-32 bg-[#0B0B0F]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <Reveal>
              <div className="flex items-center gap-3 mb-5">
                <span className="h-px w-10 bg-[#D4AF37]/60" />
                <span className="font-mono-pl text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]">
                  Galleria
                </span>
              </div>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase text-[#F5F5F5] leading-[0.98] tracking-wide">
                Scatti dalla <span className="text-gold glow-gold">città</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={2}>
            <p className="max-w-md text-[#B6B6BE] text-sm sm:text-base">
              Quattro scene ufficiali del server PURELIFE — atmosfere, luoghi e
              dettagli che raccontano l&apos;identità della città.
            </p>
          </Reveal>
        </div>

        {/* 2x2 elegant grid — aspect uniforme 4:5 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {IMAGES.map((img, i) => (
            <Reveal key={img.key} delay={Math.min(i + 1, 5)}>
              <Tilt3D max={5} scale={1.012} className="relative rounded-2xl">
                <a
                  data-testid={TID.gallery.item(img.key)}
                  href="#gallery"
                  className="gallery-tile group block w-full aspect-[1/1]"
                >
                  <img src={img.src} alt={img.caption} loading="lazy" />
                  <div className="gallery-tile__overlay" />
                  <div className="absolute inset-0 z-10 flex flex-col justify-end p-6 sm:p-7">
                    <span className="inline-block w-fit px-2.5 py-1 rounded-full text-[9px] uppercase tracking-[0.28em] text-[#D4AF37] border border-[#D4AF37]/40 bg-[#0B0B0F]/70 mb-3">
                      {img.tag}
                    </span>
                    <p className="text-[#F5F5F5] text-base sm:text-lg font-bold tracking-wide">
                      {img.caption}
                    </p>
                  </div>
                </a>
              </Tilt3D>
            </Reveal>
          ))}
        </div>

        <Reveal delay={3} className="mt-8 text-center">
          <p className="text-[10px] uppercase tracking-[0.28em] text-[#B6B6BE]">
            Galleria ufficiale PURELIFE Roleplay · ulteriori scatti in arrivo
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Gallery;
